import { dayjsCustom } from '@/shared/utils/helpers/datetime-format';

import type { TConfigImage } from '../../store/types';

export const convertImagesToTable = (items: TConfigImage[]): TConfigImage[] => {
  const images = items.map((item) => ({
    ...item,
    created: dayjsCustom(item.created).format('DD.MM.YYYY / HH:mm'),
  }));

  return images;
};
